import { match } from "ts-pattern";

import { formatUSDShort } from "@/web/lib/formatting";
import type { Property } from "@tycho/web-bindings/types";
import { CompletedActionCard } from "@/web/routes/_protected/smb/-dashboard/-CompletedActionCard";
import type { SmbActionDefinition } from "@/web/routes/_protected/smb/-dashboard/-types";

type Props = {
  property: Property;
};

export function createReviewCompsCompleted(props: Props & { id?: string }): SmbActionDefinition {
  const { property, id = `review-comps:done:${property.id.toString()}` } = props;
  const selectedComps = property.comps.filter((c) =>
    property.selectedCompIds.includes(c.id.toString()),
  );
  const priceLabel =
    property.priceEstimate !== undefined ? formatUSDShort(property.priceEstimate) : undefined;
  const judgement =
    property.userThinksPriceEstimateIs &&
    match(property.userThinksPriceEstimateIs)
      .with({ tag: "High" }, () => "you thought it was too high")
      .with({ tag: "Low" }, () => "you thought it was too low")
      .with({ tag: "Correct" }, () => "you thought it looked right")
      .exhaustive();

  return {
    id,
    category: "negotiate",
    canSkip: false,
    render: () => (
      <CompletedActionCard
        category="negotiate"
        badge="Price"
        testId="review-comps-completed"
        title={priceLabel ? `Estimated at ${priceLabel}` : "Comps reviewed"}
        details={{
          title: "Comps reviewed",
          children: (
            <div className="flex flex-col gap-2">
              <p className="font-medium">{property.address.addressLine1}</p>
              {priceLabel ? (
                <p>
                  Estimate: <strong>{priceLabel}</strong>
                  {judgement ? ` — ${judgement}` : null}.
                </p>
              ) : null}
              {selectedComps.length > 0 ? (
                <div className="flex flex-col gap-1">
                  <p className="opacity-70">Top {selectedComps.length}:</p>
                  <ul className="flex flex-col gap-0.5">
                    {selectedComps.map((c) => (
                      <li key={c.id.toString()}>{c.address.addressLine1}</li>
                    ))}
                  </ul>
                </div>
              ) : null}
            </div>
          ),
        }}
      />
    ),
  };
}
